import { Aspect } from '@teambit/harmony';

export const WorkerAspect = Aspect.create({
  id: 'teambit.harmony/worker',
});
